module.exports = __webpack_public_path__ + "static/media/KaTeX_Typewriter-Regular.f43e8696.woff2";